import { compose } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../actions/SeminarManagementViewer';
import ListSeminarViewerNonAuth, { Header } from '../../pages/SeminarManagementViewer/ListSeminarViewerNonAuth';
import withScroll from '../../common/WithScrollTop';
import withAuthUser from '../../common/WithAuthUser';

const mapStateToProps = (state) => {
    const isLoading = state.seminarManagementViewer.listSeminarNonAuthViewer.isFetching
    || state.seminarManagementViewer.detailSeminarNonAuthViewer.isFetching
    || state.registration.registrationViewer.isFetching
    || state.adminSettingCustom.getCustomText.isFetching;

    return ({
        locale: state.locale.lang.current,
        langOther: state.locale?.changLangOther?.current || '',
        language: state.locale.changeLanguage.lang?.language || 'ja',
        listSeminarViewer: state.seminarManagementViewer.listSeminarNonAuthViewer.data.results,
        listPagination: state.seminarManagementViewer.listSeminarNonAuthViewer.data,
        detailSeminarViewer: state.seminarManagementViewer.detailSeminarNonAuthViewer.data,
        eventInfo: state.registration.registrationViewer.data,
        isLoading,
        isAuthorized: state.auth.credential.isAuthorized,
        isWeakAuth: state.auth.credential.data?.isWeakAuth,
        isCheckEvent: state.registration.registrationViewer.successInformation,
        customText: state.adminSettingCustom.getCustomText.data?.content,
        customColor: state.registrationOrganizer.registrationOrganizer.data?.settings_colors_viewer,
    });
};

const mapDispatchToProps = (dispatch) => ({
    fetchListSeminarViewer: (params) => {
        dispatch(Actions.GetListSeminarNonAuthRequested(params));
    },
    getDetailSeminarViewer: (params) => {
        dispatch(Actions.GetDetailSeminarNonAuthRequested(params));
    },
    clearListSeminarViewer: () => {
        dispatch(Actions.ClearListSeminarNonAuth());
    },
    clearDetailSeminarViewer: () => {
        dispatch(Actions.ClearDetailSeminarNonAuth());
    },
});

export const ListSeminarViewerNonAuthHeader = connect(mapStateToProps, mapDispatchToProps)(Header);

export default compose(
    withAuthUser,
    withScroll,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ListSeminarViewerNonAuth);
